module.exports = {

    resources: {
        presspalletbuilder: {
            name: 'Press Pallets',
        },
        operatorPalletBuilder: {
            name: 'Pallet Builder'
        },
        operatorPalletReprint: {
            name: 'Print Manifests'
        },
        operatorManualPallet: {
          name: 'Manual Manifest'
        },
        operatorView: {
          name: 'Operator View'
        },
        adminView: {
            name: 'Admin View'
        },
        dashboard: {
            name: 'Dashboard',
        },
        reprint: {
            name: 'Reprint',
        },
        manual: {
            name: 'Manual',
        }


    }
}
